import { SelectOptions } from '../types/selectOptions.types';

export const documentTypes: SelectOptions[] = [
  { id: 'CI', value: 'Cédula de Identidad' },
  { id: 'PSP', value: 'Pasaporte' },
  { id: 'DNI', value: 'DNI' },
  { id: 'CPF', value: 'CPF' },
];
